import { actionTypes } from '@/core/constants'
import DocumentosUrlBuilder from '@/core/utils/factory/documentos/DocumentosUrlBuilder'
import DesentranhamentoDocumentoApiClient from '@/core/apiclient/documentos/processo-digital/desentranhamento/DesentranhamentoDocumentoApiClient'

function getApiClient(obj) {
	const urlBuilder = new DocumentosUrlBuilder(obj.tipo)
	return new DesentranhamentoDocumentoApiClient(urlBuilder)
}

export default {
	async [actionTypes.DOCUMENTOS.PROCESSO_DIGITAL.DESENTRANHAMENTO.CRIAR_TERMO](context, objt) {
		let apiClient = getApiClient(objt)
		const { data } = await apiClient.criarTermoDesentranhamento(objt.documento, objt.tipo.value)
		return data
	},

	async [actionTypes.DOCUMENTOS.PROCESSO_DIGITAL.DESENTRANHAMENTO.JUNTAR_TERMO](context, objt) {
		let apiClient = getApiClient(objt)
		const { data } = await apiClient.juntarTermoDesentranhamento(objt.documento, objt.tipo.value)
		return data
	},
}
